import { Link } from "react-router-dom";
import { ArrowLeft, ArrowDown } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { Eyebrow, FadeUp } from "@/components/Reveal";

export default function NotFound() {
  const { t, localizePath } = useLang();

  return (
    <div data-testid="not-found-page" className="bg-paper pt-28 md:pt-36">
      <div className="mx-auto max-w-[1400px] px-5 pb-28 md:px-10 md:pb-40">
        <FadeUp>
          <Eyebrow>{t("notFound.eyebrow")}</Eyebrow>
        </FadeUp>
        <FadeUp delay={0.1}>
          <h1 className="mt-8 max-w-3xl font-serif text-5xl font-medium leading-[1.02] tracking-tight text-ink md:text-7xl">
            {t("notFound.title")}
          </h1>
        </FadeUp>
        <FadeUp delay={0.2}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-ink/60 md:text-lg">
            {t("notFound.body")}
          </p>
        </FadeUp>
        <FadeUp delay={0.3} className="mt-10 flex flex-wrap items-center gap-4">
          <Link
            to={localizePath("/")}
            data-testid="not-found-home-link"
            className="group inline-flex items-center gap-2 rounded-full bg-cobalt px-7 py-3.5 text-sm font-semibold text-white transition-[background-color,transform] duration-300 hover:bg-ink active:scale-[0.98]"
          >
            <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-0.5" />
            {t("notFound.cta")}
          </Link>
          <Link
            to={localizePath("/#products")}
            data-testid="not-found-products-link"
            className="group inline-flex items-center gap-2 rounded-full border border-ink/20 px-7 py-3.5 text-sm font-semibold text-ink transition-[border-color,color] duration-300 hover:border-cobalt hover:text-cobalt"
          >
            {t("notFound.productsCta")}
            <ArrowDown className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" />
          </Link>
        </FadeUp>
      </div>
    </div>
  );
}
